export const TRAILER_TYPES_DB = {
	VAN: 'Van',
	FLATBED: 'Flatbed',
	REEFER: 'Reefer',
	'POWER ONLY': 'PowerOnly',
	STEPDECK: 'StepDeck',
	CONESTOGA: 'Conestoga',
	'DOUBLE DROP': 'Double Drop',
	RGN: 'RGN',
	CONTAINER: 'Container',
};
